<template>
  <v-navigation-drawer app v-model="$store.state.showDrawer">
    <v-list>
      <!-- <v-list-item link>
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>-->

      <v-list-item link to="/orders" v-if="$store.getters.canOrder">
        <v-list-item-action>
          <v-icon>mdi-clipboard-list-outline</v-icon>
        </v-list-item-action>
        <v-list-item-title>{{ $t("Orders") }}</v-list-item-title>
        <v-list-item-content></v-list-item-content>
      </v-list-item>
      <v-list-item v-else>
        <v-list-item-action>
          <v-icon>mdi-clipboard-list-outline</v-icon>
        </v-list-item-action>
        <v-list-item-title aria-disabled class="grey--text">{{ $t("Orders") }}</v-list-item-title>
        <v-tooltip
          bottom
          v-if="$store.getters.accountType!='standard' && $store.getters.accountType!='free'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn dense class="caption" v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-progress-upload</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Upgrade your plan") }}</span>
        </v-tooltip>
        <v-list-item-content></v-list-item-content>
      </v-list-item>

      <v-list-item link to="/products">
        <v-list-item-action>
          <v-icon>mdi-food-fork-drink</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t("Products")}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link to="/locations">
        <v-list-item-action>
          <v-icon>mdi-qrcode</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t("Locations")}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item link>
        <v-list-item-action>
          <v-icon>mdi-account-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Staff</v-list-item-title>
        </v-list-item-content>
      </v-list-item>-->

      <!-- <v-list-item link>
        <v-list-item-action>
          <v-icon>mdi-chart-bell-curve</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Stats</v-list-item-title>
        </v-list-item-content>
      </v-list-item>-->

      <v-list-item link to="/settings">
        <v-list-item-action>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("Settings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="my-4 d-flex justify-center">
        <v-btn color="primary" outlined @click="logOut" class="px-2">
          <v-icon>mdi-account-off-outline</v-icon>
          {{ $t("Log out") }}
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import AuthService from "@/service/auth_service";
import NotifyToken from "@/model/notifyToken";

export default {
  name: "Navigation",
  components: {},
  methods: {
    logOut() {
      console.log("token deleted", this.$store.getters.notifyToken);
      new NotifyToken({ id: this.$store.getters.notifyToken }).delete();
      this.$store.replaceState({});
      AuthService.logOut();
    }
  }
};
</script>
